import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
export function SiteLayout() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink" data-id="element-299" data-mp="34v4ua2dbizlj">
      <ScrollToTop data-id="element-300" data-mp="39uhiaqfxecpp" />
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-navy focus:px-4 focus:py-2 focus:text-white" data-id="element-301" data-mp="39v0ppd7y9iph">
        Skip to content
      </a>
      <Header data-id="element-302" data-mp="3ituptdkhor7s" />
      <main id="main-content" tabIndex={-1} className="focus:outline-none" data-id="element-303" data-mp="3itco41f25ksh">
        <Outlet data-id="element-304" data-mp="3nn734rjpxbl8" />
      </main>
      <Footer data-id="element-305" data-mp="3nnyzi4l53dck" />
    </div>;
}